import React from 'react'
import endsWith from 'lodash/endsWith'
import isUndefined from 'lodash/isUndefined'
import isNan from 'lodash/isNaN'
import { FormsyText } from 'formsy-material-ui'

const FormsyInput = ({
  ...props
}) => {
  return (
    <FormsyText {...props} />
  )
}

FormsyInput.propTypes = {}
FormsyInput.defaultProps = {}
FormsyInput.UnitSize = ({
  extraValidation,
  ...props
}) => (
  <FormsyInput
    updateImmediately
    validations={{
      validUnit: (values, value) => {
        if (isUndefined(value) || value === '' || value === 'auto') {
          return true
        }
        if (!isNan(parseFloat(value)) && isFinite(value)) {
          return true
        }
        if (endsWith(value, 'px') || endsWith(value, 'em') || endsWith(value, 'rem') || endsWith(value, 'pt')) {
          if (isFinite(value.replace('px', ''))) {
            return true
          }
          if (isFinite(value.replace('em', ''))) {
            return true
          }
          if (isFinite(value.replace('rem', ''))) {
            return true
          }
          if (isFinite(value.replace('pt', ''))) {
            return true
          }
        }
        return extraValidation ? extraValidation(values, value) : false
      },
    }}
    validationErrors={{
      validUnit: 'Invalid value.',
    }}
    {...props}
  />
)

export default FormsyInput



// WEBPACK FOOTER //
// ./src/components/formsy/FormsyInput.js